
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/high-fidelity-audio-home-theater",
      function () {
        return require("private-next-pages/use-cases/high-fidelity-audio-home-theater.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/high-fidelity-audio-home-theater"])
      });
    }
  